<template>
  <div class="main-contaienr">
    <el-row>
      <el-col :span="5">
        <!-- 停车场使用率 -->
        <div class="ticket">
          <mark-column title="停车场使用率">
            <div class="progress-group">
              <div class="progress-item">
                <utilization-rate></utilization-rate>
              </div>
            </div>
          </mark-column>
        </div>
        <!-- 车辆出入趋势 -->
        <div class="ticket sell">
          <mark-column title="车辆出入趋势">
            <div class="progress-group">
              <div class="progress-item">
                <vehicle-access></vehicle-access>
              </div>
            </div>
          </mark-column>
        </div>
        <!-- 车辆类型分布 -->
        <div class="ticket sell">
          <mark-column title="车辆类型分布">
            <div class="progress-group">
              <div class="progress-item">
                <vehicle-type></vehicle-type>
              </div>
            </div>
          </mark-column>
        </div>
      </el-col>
      <!-- 中间地图部分 -->
      <el-col :span="14"><parking-map></parking-map></el-col>
      <el-col :span="5">
        <!-- 车辆停留时长统计 -->
        <div class="ticket">
          <mark-column title="车辆停留时长统计">
            <div class="progress-group">
              <div class="progress-item">
                <vehicle-stop></vehicle-stop>
              </div>
            </div>
          </mark-column>
        </div>
        <!-- 游客来源省份TOP5 -->
        <div class="ticket sell">
          <mark-column title="游客来源省份TOP5">
            <div class="progress-group">
              <div class="progress-item">
                <tourist-source></tourist-source>
              </div>
            </div>
          </mark-column>
        </div>
        <!-- 游客省内来源地市 -->
        <div class="ticket sell">
          <mark-column title="游客省内来源地市">
            <div class="progress-group">
              <div class="progress-item">
                <tourist-city></tourist-city>
              </div>
            </div>
          </mark-column>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  //导入标题栏
  import markColumn from '../ticketing/components/mark-column'
  //停车场使用率
  import utilizationRate from './components/utilization-rate'
  //导入中间地图
  import parkingMap from './components/parking-map'
  //车辆出入趋势
  import vehicleAccess from './components/vehicle-access'
  //车辆类型分布
  import vehicleType from './components/vehicle-type'
  //车辆停留时长统计
  import vehicleStop from './components/vehicle-stop'
  //游客来源省份TOP5
  import touristSource from './components/tourist-source'
  //游客省内来源地市
  import touristCity from './components/tourist-city'
  export default {
    components: {
      markColumn,
      parkingMap,
      utilizationRate,
      vehicleAccess,
      vehicleType,
      vehicleStop,
      touristSource,
      touristCity,
    },
    data() {
      return {
        // 今日检票
        ticketList: {
          progress: [
            {
              name: '今日售票',
              total: 200,
              number: 110,
              color: ['#004743', '#5CFFF5'],
            },
            {
              name: '七日售票',
              total: 1000,
              number: 568,
              color: ['#003447', '#00A8FF'],
            },
            {
              name: '月售票',
              total: 1000,
              number: 425,
              color: ['#473400', '#FFC600'],
            },
            {
              name: '年售票',
              total: 10000,
              number: 5698,
              color: ['#271148', '#A525FF'],
            },
          ],
        },
      }
    },
    mounted() {
      this.init()
    },
    destroyed() {
      document
        .getElementsByTagName('body')[0]
        .setAttribute(
          'style',
          ' background-image: radial-gradient(#f9fdfe, #3c474b);'
        )
    },
    methods: {
      // 初始化
      init() {
        let img = require('../../assets/ticke_images/bjasd.png')
        document
          .getElementsByTagName('body')[0]
          .setAttribute('style', 'background:url(' + img + ')')
      },
    },
  }
</script>
<style lang="scss" scoped>
  .main-contaienr {
    // 售票数量统计
    .ticket {
      height: 25.824vh;
    }
    .sell {
      margin-top: 2.75vh;
    }
  }
</style>
